import cn from 'classnames';
import CloseIcon from './Icons/CloseIcon';
import './CloseButton.css';

const CloseButton = ({ onHide, className }) => {

  const buttonClasses = cn('rntr-close-button', className)
  return (
    <button className={ buttonClasses } onClick={ onHide }>
      <CloseIcon/>
    </button>
  );
}

export default CloseButton;